import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propFunc, propStr, } from '../../../../../../../helpers/custom-prop-types';
import FilterKeyword from '../../Common/Filter/FilterKeyword';
const UploadHistoryFilter = (props) => {
    const { defaultKeywordValue, onBlurKeyword } = props;
    return (_jsx("div", Object.assign({ className: 'mypage_filter_box upload_history_filter_box' }, { children: _jsx(FilterKeyword, { defaultKeywordValue: defaultKeywordValue, onBlurKeyword: onBlurKeyword }) })));
};
UploadHistoryFilter.propTypes = {
    defaultKeywordValue: propStr().isRequired,
    onBlurKeyword: propFunc().isRequired,
};
export default UploadHistoryFilter;
